import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { LoadingIcon } from '../Common/Icons';
import { Result } from '../Common/Result';
import Layout from './Layout';
import { useNavigate } from 'react-router-dom';

type Props = {
  token: string | null;
  onVerify: (token: string) => Promise<{
    success?: boolean;
  }>;
};
export default function Verification({ onVerify, token }: Props) {
  const [activating, setActivating] = useState(true);
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      onVerify(token).then((res) => {
        if (res.success) {
          setSuccess(true);
          setActivating(false);
        }
      });
    }
  }, [token, onVerify]);
  useEffect(() => {
    new Promise((resolve) => setTimeout(resolve, 1000)).then(() => {
      setActivating(false);
    });
  }, []);
  return (
    <Layout>
      {!token ? (
        <div>Đường dẫn xác thực Email không đúng. Vui lòng kiểm tra lại.</div>
      ) : (
        <>
          {activating ? (
            <>
              <LoadingIcon />
              <div style={{ textAlign: 'center', marginTop: 8, fontSize: 16 }}>
                Đang xác thực Email
              </div>
            </>
          ) : success ? (
            <Result
              type="success"
              title="Xác thực Email thành công"
              message={
                <>
                  <div>
                    Từ bây giờ bạn có thể sử dụng đầy đủ các tính năng trên
                    YouGo.
                  </div>
                </>
              }
            >
              <Button type="primary" onClick={() => navigate('/')}>
                Về trang chủ
              </Button>
            </Result>
          ) : (
            <Result
              type="warning"
              title="Link xác thực đã hết hạn"
              message={
                <>
                  <div>
                    Bạn vui lòng <b>đăng nhập</b> và{' '}
                    <b>gửi lại yêu cầu xác thực</b> nhé!
                  </div>
                </>
              }
            >
              <Button type="primary" onClick={() => navigate('/')}>
                Đăng nhập tài khoản
              </Button>
            </Result>
          )}
        </>
      )}
    </Layout>
  );
}
